export class UnsupportedLocaleError extends Error {
    constructor(locale){
        super("Unsupported locale: ".concat(locale));
        this.name = 'UnsupportedLocaleError';
    }
}
export const SUPPORTED_LOCALES = [
    'en',
    'es'
];
export const DEFAULT_LOCALE = 'en';
export function isSupportedLocale(lang) {
    return SUPPORTED_LOCALES.includes(lang);
}
